import { useQuery } from '@tanstack/react-query';
import GraphqlService from '../service/graphqlService';
import { AUDIT_ENTITY_DEVICE_DEFENDER } from './useAuditLog';

/**
 * Hook for fetching Device Defender audit actions for a specific device
 * 
 * @param {string} deviceSerial - The device serial number
 * @param {Object} options - Hook options
 * @param {boolean} [options.enabled=true] - Whether the query is enabled
 * @returns {Object} Query result with data, isLoading, error, refetch
 */
const useDefenderActions = (deviceSerial, { enabled = true } = {}) => {
  const query = useQuery(
    ['defenderActions', deviceSerial],
    () => GraphqlService.getAuditLogs({
      entity: AUDIT_ENTITY_DEVICE_DEFENDER,
      entity_id: deviceSerial,
      limit: 50,
      page: 1,
    }),
    {
      enabled: enabled && !!deviceSerial,
      staleTime: 30000, // 30 seconds
      cacheTime: 60000, // 1 minute
      refetchOnWindowFocus: false,
      onError: (error) => {
        console.error('[useDefenderActions] Error fetching audit logs:', error);
      },
    }
  );

  return {
    data: query.data?.data || [],
    pagination: query.data?.pagination || null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useDefenderActions;
